export function V10PreviewRouteTabs({
  routes,
  activeRoute,
  onRouteChange,
  disabled,
}: {
  readonly routes: readonly string[];
  readonly activeRoute: string;
  readonly onRouteChange: (route: string) => void;
  readonly disabled?: boolean;
}) {
  if (routes.length <= 1) return null;
  return (
    <div className="v10-preview-route-tabs" role="tablist" aria-label="Preview pages">
      {routes.map((route) => (
        <button
          key={route}
          type="button"
          role="tab"
          className={`v10-preview-route-tab${route === activeRoute ? " active" : ""}`}
          aria-selected={route === activeRoute}
          disabled={disabled}
          onClick={() => onRouteChange(route)}
        >
          {route === "/" ? "Home" : route.replace(/^\//, "").replace(/-/g, " ")}
        </button>
      ))}
    </div>
  );
}
